import React, { useEffect } from 'react'
import { CheckboxItem } from '@sainsburys-tech/bolt'
import * as Styled from './Q&APreview.styles'

function QuestionPreview({ ...props }) {
  const { formData, setCheckInput, question } = props
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    })
  })

  return (
    <div>
      <Styled.PreviewWrapper data-test='preview-wrapper'>
        <Styled.IconWrapper>
          <Styled.Icon>Q</Styled.Icon>
        </Styled.IconWrapper>
        {props.type === 'question' && (
          <Styled.DetailsWrapper>
            {formData.question && <Styled.SubHeading>{formData.question}</Styled.SubHeading>}
            {formData.additionalDetails && <p>{formData.additionalDetails}</p>}
            <Styled.UserDetails type={props.type}>
              <p>
                Question from <Styled.Nickname>{formData.nickname}</Styled.Nickname>
              </p>
              {formData.location && <p>Location: {formData.location}</p>}
              {formData.age && <p>Age: {formData.age}</p>}
              {formData.gender && <p>Gender: {formData.gender}</p>}
            </Styled.UserDetails>
          </Styled.DetailsWrapper>
        )}
        {question && (
          <Styled.DetailsWrapper>
            {question.attributes.title && <Styled.SubHeading>{question.attributes.title}</Styled.SubHeading>}
            {/* {formData.additionalDetails && <p>{formData.additionalDetails}</p>} */}
            <Styled.UserDetails type={props.type}>
              <p>
                Question from <Styled.Nickname>{question.attributes.profile.name}</Styled.Nickname>
              </p>
              {question.attributes.profile.location && <p>Location: {question.attributes.profile.location}</p>}
              {question.attributes.profile.age && <p>Age: {question.attributes.profile.age}</p>}
              {question.attributes.profile.gender && <p>Gender: {question.attributes.profile.gender}</p>}
            </Styled.UserDetails>
          </Styled.DetailsWrapper>
        )}
      </Styled.PreviewWrapper>

      {props.type === 'answer' && (
        <Styled.AnswerWrapper>
          <Styled.AnswerHeading>
            <Styled.AnswerIcon>A</Styled.AnswerIcon>
            <p>{formData.yourAnswer}</p>
          </Styled.AnswerHeading>
          <Styled.AnswerDetails>
            <p>
              Answered by <Styled.Nickname>{formData.nickname}</Styled.Nickname>
            </p>
            {formData.location && <p>Location: {formData.location}</p>}
            <p>8th July 2021</p>
          </Styled.AnswerDetails>
        </Styled.AnswerWrapper>
      )}

      {formData.acceptTsandCsError && <Styled.ErrorMessage>{formData.acceptTsandCsError}</Styled.ErrorMessage>}
      <CheckboxItem
        label="I accept the T's &amp; C's.&#13; (You may receive emails regarding this submission, any email will include the ability to opt out of future communications)"
        onChange={setCheckInput('acceptTsandCs')}
        checked={formData.acceptTsandCs}
        isError={formData.acceptTsandCsError}
        id='3'
      />
      <Styled.ButtonContainer>
        <Styled.ButtonWrapper kind='primary' type='button' full onClick={props.handleSubmit}>
          Submit
        </Styled.ButtonWrapper>
        <Styled.ButtonWrapper kind='secondary' type='button' full onClick={props.onEdit}>
          Edit
        </Styled.ButtonWrapper>
      </Styled.ButtonContainer>
    </div>
  )
}

export default QuestionPreview
